const API_BASE = (
  process.env.REACT_APP_GL_BACKEND_URL ||
  'https://greatleaders-backend.onrender.com'
).replace(/\/$/, '');

async function readJson(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    const error = new Error(data.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
  return data;
}

export async function fetchOrganizationalCulture() {
  const response = await fetch(`${API_BASE}/api/organizational-culture`);
  const data = await readJson(response);
  return data.item;
}
